var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',{style:('height: ' + _vm.currentHeight + 'px;')},[_c('v-window',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-window-item',{staticClass:"auth-step",attrs:{"value":1}},[_c('AuthContainerTwo')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }